import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      borderRadius: 6,
      flex: 1,
    },
    infestTable: {
      width: '100%',
      borderSpacing: '0 0.4rem',
      textAlign: 'center',

      '& > thead, & > tbody': {
        flex: 1,

        '& th, & td': {
          fontWeight: 400,
          padding: '0.8rem 0.2rem',
          verticalAlign: 'text-top',

          '&:nth-child(1)': {
            paddingLeft: '0.6rem',
            width: '3rem',
            fontSize: '2rem',
            lineHeight: 0,
          },

          '&:nth-child(2)': {
            textAlign: 'left',

            '&::first-letter': {
              textTransform: 'uppercase',
            },
          },

          '&:nth-child(3)': {
            minWidth: '5rem',
          },

          '&:nth-child(4)': {
            paddingRight: '0.4rem',
          },
        },

        '& td': {
          verticalAlign: 'top',
          fontSize: '1.2rem',
          fontFamily: theme.typography.body1.fontFamily,

          '& > ul': {
            margin: 0,
            padding: 0,
            fontWeight: 600,
            listStyle: 'none',

            '& > li': {
              display: 'flex',
              alignItems: 'center',
              marginLeft: '-2.8rem',

              '& > span': {
                fontSize: '1.6rem',
                lineHeight: 0,
                marginInline: '1rem',
              },
            },
          },
        },

        '& th': {
          fontSize: '1.2rem',
          fontFamily: theme.typography.body1.fontFamily,

          '&:first-child': {
            paddingTop: '0.4rem',
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
          },

          '&:last-child': {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
          },

          '&:nth-child(2)': {
            fontWeight: 600,
          },
        },
      },
    },
    headerRow: {
      '& th': {
        backgroundColor: 'transparent',
        fontWeight: 400,
        border: 'none',
      },
    },
    groupRow: {
      '& th': {
        border: 'none',

        '&:nth-child(1)': {
          borderLeft: '1px solid #D2D2D2',
          borderTop: '1px solid #D2D2D2',
          borderBottom: '1px solid #D2D2D2',
          borderTopLeftRadius: '6px',
          borderBottomLeftRadius: '6px',
        },

        '&:nth-child(2), &:nth-child(3), &:nth-child(4)': {
          borderTop: '1px solid #D2D2D2',
          borderBottom: '1px solid #D2D2D2',
        },

        '&:nth-child(5)': {
          borderRight: '1px solid #D2D2D2',
          borderTop: '1px solid #D2D2D2',
          borderBottom: '1px solid #D2D2D2',
          borderTopRightRadius: '6px',
          borderBottomRightRadius: '6px',
        },
      },
    },
    headerColumn: {
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
    },
    headerTitle: {
      fontWeight: 600,
    },
    headerSubtitle: {
      fontWeight: 400,
    },
    variationTagContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    variationTag: {
      display: 'flex',
      marginRight: '0.6rem',
      alignItems: 'center',
      gap: '0.4rem',
      color: '#001D29',
      fontSize: '1.2rem',
      padding: '0.1rem 0.8rem',
      borderRadius: '5px',
      width: 'fit-content',
      '& svg': {
        width: '1.4rem',
        height: '1.4rem',
      },
    },
    greenTag: {
      backgroundColor: '#A0C84B4D',
    },
    redTag: {
      backgroundColor: '#BA1B1B4D',
    },
    neutralTag: {
      backgroundColor: '#E0E0E04D',
    },
    infoIcon: {
      position: 'absolute',
      width: '1.4rem',
      height: '1.4rem',
      marginLeft: '2.5rem',
      cursor: 'pointer',
    },
    tooltip: {
      backgroundColor: '#F0F0F0',
      color: '#1A1C19',
      fontSize: '12px',
      lineHeight: '16px',
      padding: '4px 8px',
      border: 'none',
      borderRadius: '5px',
    },
  }),
)
